"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "flex items-start flex-wrap gap-4"
  }, [_vm._l(_vm.renderUsers, function (user) {
    return _c("div", {
      key: user.userId,
      staticClass: "flex flex-col items-center"
    }, [_c("div", {
      staticClass: "relative size-[32px]"
    }, [_c("div", {
      staticClass: "cursor-pointer absolute right-0 z-[999] flex translate-x-[50%] -translate-y-[50%] px-[4px] py-[2px] bg-red-500 rounded-full text-white",
      on: {
        click: function ($event) {
          return _vm.remove(user.userId);
        }
      }
    }, [_c("a-icon", {
      staticClass: "text-[12px]",
      attrs: {
        type: "close"
      }
    })], 1), _c("a-avatar", {
      staticClass: "align-baseline",
      attrs: {
        shape: "square",
        src: user.avatar
      }
    }, [!user.avatar ? [_vm._v(_vm._s(user.userName))] : _vm._e()], 2)], 1), _c("span", [_vm._v(_vm._s(user.userName))])]);
  }), _c("a-avatar", {
    staticClass: "cursor-pointer",
    attrs: {
      shape: "square",
      icon: "plus"
    },
    on: {
      click: _vm.open
    }
  }), _c("a-modal", {
    attrs: {
      title: "人员选择",
      "body-style": {
        height: "600px",
        overflow: "auto"
      }
    },
    on: {
      ok: _vm.confirm
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("a-input-search", {
    attrs: {
      placeholder: "输入姓名搜索"
    },
    model: {
      value: _vm.searchKeyword,
      callback: function ($$v) {
        _vm.searchKeyword = $$v;
      },
      expression: "searchKeyword"
    }
  }), _c("a-divider"), !_vm.searchKeyword ? [_c("a-breadcrumb", _vm._l(_vm.departmentBreadcrumb, function (department) {
    return _c("a-breadcrumb-item", {
      key: department.id,
      attrs: {
        href: ""
      },
      nativeOn: {
        click: function ($event) {
          return _vm.changeCurrentDepartment(department);
        }
      }
    }, [_vm._v(" " + _vm._s(department.name) + " ")]);
  }), 1), _c("a-divider"), _c("a-checkbox-group", {
    staticClass: "w-full",
    attrs: {
      value: _vm.checkedDepartmentIds
    }
  }, _vm._l(_vm.renderDepartmentTree, function (department) {
    return _c("div", {
      key: department.id,
      staticClass: "flex items-center"
    }, [_c("a-checkbox", {
      staticClass: "flex-1",
      attrs: {
        value: department.id
      },
      on: {
        change: function ($event) {
          return _vm.handleDepartmentChange(department, $event);
        }
      }
    }, [_vm._v(" " + _vm._s(department.name) + " ")]), _c("a-button", {
      staticClass: "flex-shrink-0",
      attrs: {
        type: "link",
        icon: "cluster"
      },
      on: {
        click: function ($event) {
          return _vm.changeCurrentDepartment(department);
        }
      }
    }, [_vm._v(" 下级 ")])], 1);
  }), 0), _c("a-divider")] : _vm._e(), _c("a-checkbox-group", {
    attrs: {
      value: _vm.checkedUserIds
    }
  }, [_c("div", {
    staticClass: "flex flex-col gap-y-2"
  }, _vm._l(_vm.renderUserList, function (user) {
    return _c("div", {
      key: user.userId
    }, [_c("a-checkbox", {
      attrs: {
        value: user.userId
      },
      on: {
        change: _vm.handleUserCheckboxChange
      }
    }, [_vm._v(" " + _vm._s(user.userName) + " ")])], 1);
  }), 0)])], 2)], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;